module.exports = __webpack_public_path__ + "static/media/veg.c43acb94.jpg";